import { render, staticRenderFns } from "./RemoveServiceDialog.vue?vue&type=template&id=70683be2&scoped=true"
import script from "./RemoveServiceDialog.vue?vue&type=script&lang=ts"
export * from "./RemoveServiceDialog.vue?vue&type=script&lang=ts"
import style0 from "./RemoveServiceDialog.vue?vue&type=style&index=0&id=70683be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70683be2",
  null
  
)

export default component.exports